import React from 'react';
import ServiceCard from './ServiceCard';
import imagen1 from './imagenes/iconoSolver-65x65-SF.png';
import imagen2 from './imagenes/iconoconstantesfisicas-50X50-SF.png';
import imagen3 from './imagenes/IconoEjerciciosIngenieria-65x65-SF.png';

function Inicio() {
  return (     
        <div className="inicio-container">
         <h1>Bienvenido a LeAMech, Herramientas para los Mecanismos de aprendizaje en la era de la IA </h1>
        

    <div className="service-section">
      <ServiceCard 
        title="Ecuaciones Cuadráticas" 
        description="Resuelve ecuaciones cuadráticas fácil, incluso con soluciones complejas" 
        route="/CalculoRaices" 
        image={imagen1} 
      />
      
      <ServiceCard 
        title="Constantes Físicas" 
        description="Muestra varias tablas con Constantes Físicas usuales en el aula de clase agrupadas por contextos" 
        route="/ConstantesFisicas" 
        image={imagen2} 
      />
      
      <ServiceCard 
        title="Taller de Mecánica" 
        description="Ejercicios de física mecánica básica universitaria, para cursos de Ciencias, Ingenierías y Licenciaturas" 
        route="/TallerQF" 
        image={imagen3} 
      />
    </div>
    </div>
  );
}

export default Inicio;
